<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>
<page-content [noPadding]="true">
  <data-table (edit)="onEdit($event)" (remove)="onRemove($event)" [columns]="columns" [dataProvider]="driverService"
              [searchColumns]="searchColumns" [title]="title"></data-table>
</page-content>
